import { useCallback } from 'react'
import { KeyedMutator } from 'swr'
import * as postsApi from 'modules/community/api/posts-api'
import { PostInterface } from 'modules/community/types/post-interface'

interface UseDeletePostProps<T extends PostInterface> {
  mutatePosts: KeyedMutator<T[]>
}

export const useDeletePost = <T extends PostInterface>({ mutatePosts }: UseDeletePostProps<T>) => {
  return useCallback(
    (postId: number, posts: T[]) => async () => {
      await postsApi.deletePost(postId)
      const filteredPosts = posts.filter(p => p.id !== postId)
      await mutatePosts(filteredPosts, false)
    },
    [mutatePosts],
  )
}
